import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { FadeIn } from './FadeIn.style';
import { useDeferUntilIdle } from './useDeferUntilIdle';

const TraderChatButtonFloating = ssrReactLazy(
    async () =>
        (
            await import(
                'src/domains/players/webview/components/Account/accountPanel/accountNavigation/traderChatLinkNav/TraderChatLinkNav'
            )
        ).TraderChatButtonFloating
);
const FreshDeskIframe = ssrReactLazy(
    async () => (await import('src/domains/layouts/webview/components/freshDesk/FreshDeskIframe')).FreshDeskIframe
);
const IntercomChat = ssrReactLazy(
    async () => (await import('src/domains/layouts/webview/components/IntercomChat')).IntercomChat
);
const OptimoveHost = ssrReactLazy(
    async () => (await import('src/domains/layouts/ui/uiComponents/OptimoveHost')).OptimoveHost
);

export const AppIntegrationsLayer = observer('AppIntegrationsLayer', () => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const isIdle = useDeferUntilIdle();

    const { traderChat, freshDeskChat, intercomChat, optimoveShowInboxForVisitors, optimoveBadgeHostId } = config;

    const traderChatState = TraderChatState.get(common);
    const sdkCustomer = SdkCustomer.get(common);
    const { userId } = sdkCustomer.session;

    const isAvailableBubbleChatButton = traderChat.isBubbleChatButton && traderChatState.isTraderChatForView;
    const showOptimoveInbox = optimoveShowInboxForVisitors || userId !== null;

    return (
        <>
            {isAvailableBubbleChatButton ? (
                <React.Suspense fallback={null}>
                    <FadeIn>
                        <TraderChatButtonFloating />
                    </FadeIn>
                </React.Suspense>
            ) : null}

            {freshDeskChat === null || isIdle === false ? null : (
                <React.Suspense fallback={null}>
                    <FadeIn>
                        <FreshDeskIframe />
                    </FadeIn>
                </React.Suspense>
            )}

            {intercomChat !== true || isIdle === false ? null : (
                <React.Suspense fallback={null}>
                    <FadeIn>
                        <IntercomChat />
                    </FadeIn>
                </React.Suspense>
            )}

            {optimoveBadgeHostId === null || isIdle === false ? null : (
                <React.Suspense fallback={null}>
                    <OptimoveHost isHidden={!showOptimoveInbox} />
                </React.Suspense>
            )}
        </>
    );
});
